let environment = 'production'   // 'production', 'staging'
export default { environment } 